import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const StickyCTA = ({ onContact }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const nearBottom =
        window.innerHeight + y >= document.body.scrollHeight - 400;
      // Show after 500px scroll, hide near the contact section / footer
      setShow(y > 500 && !nearBottom);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.button
          key="sticky-cta"
          initial={{ opacity: 0, y: 24, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.9 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          onClick={onContact}
          data-testid="sticky-cta"
          className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 rounded-full bg-[#1E6BFF] hover:bg-[#3B82F6] text-white font-semibold px-5 py-3.5 text-sm shadow-[0_18px_45px_-10px_rgba(251,146,60,0.6)] glow-blue transition-colors duration-200"
        >
          <ArrowUpRight size={16} /> Free Website Plan
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default StickyCTA;
